export default __webpack_public_path__ + "static/media/DailyBruinLogo.36b78b2e.svg";